import { DEFAULT_ADDRESS, CREDIT_CARD } from '@js/service/checkoutServiceV3';

export default {
	user: null,
	cart: null,

	brand: null,

	bumpers: [],

	query: {},
	params: {},

	email: '',
	password: '',

	initialized: false,
	submittingOrder: false,
	modifyingCart: false,

	billingAddress: { ...DEFAULT_ADDRESS },
	shippingAddress: { ...DEFAULT_ADDRESS },
	shippingDifferentFromBilling: false,

	errors: [],
	showFormErrors: false,

	checkingEmailExists: false,
	emailExistsError: false,

	billingPostalCodeMismatchError: false,
	shippingPostalCodeMismatchError: false,

	billingComponent: null,
	billingGateway: null,
	getToken: null,
	restorePaymentForm: null,
	handleAdyenThreeDsAction: null,

	awaitingThreeDs: false,

	showBumperDialog: false,

	paymentProcessor: CREDIT_CARD,
	paymentProcessors: [],

	initializingPaypal: false,
	processingPaypal: false,
};
